import type { TypedUseSelectorHook } from 'react-redux';
import { useSelector as useUntypedSelector } from 'react-redux';

import type { YammerI18nState } from '../state/types';

export const useSelector: TypedUseSelectorHook<YammerI18nState> = useUntypedSelector;
